import { defineCustomElement } from '~/lit/define-custom-element';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class BinCurrentReportDate extends LitEntity {
  static get properties() {
    return {
      date: { type: String, attribute: false },
      readingStatus: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        color: var(--bin-current-report-date-color, inherit);
      }
    `];
  }

  render() {
    const status = this.readingStatus || this.entity?.properties?.status || null;
    const hasWarningStatus = status === 'stale' || status === 'old';
    const date = this.date || this.entity?.properties?.publishedAt;
    const formattedDate = date ? this.localizedFormatDate(date, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : this.t('legacyLit.binCurrentReportDate.unknown');
    const textColor = hasWarningStatus
      ? 'var(--red-20)'
      : 'var(--bin-current-report-date-color, inherit)';
    return html`<span style="color: ${textColor};">${formattedDate}</span>`;
  }
}

defineCustomElement('bin-current-report-date', BinCurrentReportDate);
